import './style.scss';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import scrollIntoView from 'scroll-into-view';
import { showLogin } from 'components/login/actions';
import { addCart, showCart } from 'components/cart/actions';
import Lightrail from './lightrail';
import Text from 'components/ui/text';
import View from 'components/ui/view';
// import TextOverImage from 'components/ui/textOverImage';
import { Product } from 'components/brands/brand';
import GiftCard from 'images/gift-card.png';
import GiftBottleBag from 'images/gift-bottle-bag.png';
import GiftBow from 'images/bow.png';
import Bestsellers from 'images/gift-categories/bestsellers.jpg';
import TopUnder25 from 'images/gift-categories/top-under25.jpg';
import TopUnder50 from 'images/gift-categories/top-under50.jpg';
import WineLover from 'images/gift-categories/wine-lover.jpg';

let Gifting = class Gifting extends React.Component {
  add(product) {
    this.props.addCart(product, 1);
    setTimeout(this.props.showCart, 500);
  }

  scrollToBrowse() {
    const browseSection = this.browseSection;
    if (browseSection) scrollIntoView(browseSection, { align: { top: 0.2 } });
  }

  render() {
    return (
      <div className="banner-padding">
        <div className="gifting__header">
          <div className="gifting__banner text-center">
            <View padding={{ top: 'xl', bottom: 'xl', sides: 'sm' }}>
              <Text tag="h1" title shadow size="xxl" weight="med" margin="none">
                Send a Gift
              </Text>
              <Text tag="h2" title shadow size="lg" weight="med" margin="none">
                Get them what they really want this year
              </Text>
            </View>
          </div>
        </div>

        <div className="gifting__main">
          <View margin="lg">
            <div className="row center-xs">
              <div className="col-xs-12 col-sm-4">
                <View padding={{ sides: 'md' }} margin="sm">
                  <img
                    src={GiftCard}
                    alt="Saucey Gift Card"
                    width="200"
                    height="200"
                  />
                  <Text tag="h3" secondary size="lg" weight="reg">
                    Send a Gift Card
                  </Text>
                  <p>
                    Can{"'"}t figure out which bottle would be perfect? Send
                    them a Saucey Gift Card and let them choose their own gift.
                    They will be toasting to you soon!
                  </p>
                  <View padding="sm">
                    <Lightrail
                      shopperToken={this.props.shopperToken}
                      login={() => this.props.showLogin('signup')}
                    />
                  </View>
                </View>
              </div>
              <div className="col-xs-12 col-sm-4">
                <View padding={{ sides: 'md' }} margin="sm">
                  <img
                    src={GiftBottleBag}
                    alt="Saucey Gift Bottle"
                    width="200"
                    height="200"
                  />
                  <Text tag="h3" secondary size="lg" weight="reg">
                    Send a Bottle
                  </Text>
                  <p>
                    Saucey can deliver your recipient{"'"}s favorite bottle
                    right to their door in as little as 30 minutes. Shop curated
                    gift packages or send their favorite bottle.
                  </p>
                  <View padding="sm">
                    <button
                      className="btn-primary"
                      onClick={() => this.scrollToBrowse()}
                    >
                      Browse Gifts
                    </button>
                  </View>
                </View>
              </div>
              <div className="col-xs-12 col-sm-4">
                <View padding={{ sides: 'md' }} margin="sm">
                  <img
                    src={GiftBow}
                    alt="Special Requests"
                    width="200"
                    height="200"
                  />
                  <Text tag="h3" secondary size="lg" weight="reg">
                    Special Requests & Corporate Gifts
                  </Text>
                  <p>
                    Have lots of gifts to give or need something very special?
                    Contact us at{' '}
                    <a href="mailto:gifting@saucey.com">
                      gifting@saucey.com
                    </a>{' '}
                    and we’ll help you get everything taken care of.
                  </p>
                  <View padding="sm">
                    <a
                      className="button btn-primary inline-block"
                      href="mailto:gifting@saucey.com"
                    >
                      Contact Us
                    </a>
                  </View>
                </View>
              </div>
            </div>
          </View>

          <View margin="lg">
            <div className="row center-xs">
              <div className="col-xs-11">
                <View margin="md">
                  <div
                    ref={div => (this.browseSection = div)}
                    className="divider-group"
                  >
                    <div className="divider-group__divider" />
                    <div className="divider-group__text">Browse Gifts</div>
                    <div className="divider-group__divider" />
                  </div>
                </View>

                <div className="row center-xs">
                  <div className="col-xs-12 col-sm-6 col-md-3">
                    {/* <TextOverImage text="Bestsellers" image={Bestsellers} /> */}
                    <View margin="sm">
                      <Link to="/best-gifts">
                        <img src={Bestsellers} style={{ maxWidth: '100%' }} />
                      </Link>
                    </View>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-3">
                    {/* <TextOverImage text="For the Wine Lover" image={WineLover} /> */}
                    <View margin="sm">
                      <Link to="/wine">
                        <img src={WineLover} style={{ maxWidth: '100%' }} />
                      </Link>
                    </View>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-3">
                    {/* <TextOverImage text="Top Gifts Under $25" image={TopUnder25} /> */}
                    <View margin="sm">
                      <Link to="/best-gifts?price-max=25&price-min=1">
                        <img src={TopUnder25} style={{ maxWidth: '100%' }} />
                      </Link>
                    </View>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-3">
                    {/* <TextOverImage text="Top Gifts Under $50" image={TopUnder50} /> */}
                    <View margin="sm">
                      <Link to="/best-gifts?price-max=50&price-min=1">
                        <img src={TopUnder50} style={{ maxWidth: '100%' }} />
                      </Link>
                    </View>
                  </div>
                </div>
              </div>
            </div>
          </View>

          <View margin="lg">
            <div className="row center-xs">
              <div className="col-xs-11 col-sm-10">
                <div className="row">
                  {this.props.products.map(product => (
                    <div key={product.sku_id} className="col-xs-6 col-sm-3">
                      <Product
                        product={product}
                        add={() => this.add(product)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </View>

          <View padding={{ sides: 'sm' }}>
            <div className="row center-xs middle-xs around-md">
              <span className="media-logo media-logo--la-times" />
              <span className="media-logo media-logo--forbes" />
              <span className="media-logo media-logo--sf-weekly" />
              <span className="media-logo media-logo--tech-crunch" />
              <span className="media-logo media-logo--business-insider" />
            </div>
          </View>
        </div>
      </div>
    );
  }
};

Gifting = connect(
  state => ({
    shopperToken: state.gifting.shopperToken,
    products: state.gifting.products
  }),
  { showLogin, addCart, showCart }
)(Gifting);

export default Gifting;



// WEBPACK FOOTER //
// ./shared/components/gifting/index.js